<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Assign/Edit Equipment ['+employee.FirstName+' '+employee.LastName+'] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees`">
                            <i class="fa fa-group"></i> Employees
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/view/${employee.EmployeeId}`">
                            {{ employee.FirstName }} {{ employee.LastName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Edit Assigned Equipment</li>
                </ol>
            </h4>

            <div class="alert alert-info">
                <strong>Notes On Adding Equipment:</strong>
                <ul>
                    <li>If you enter an existing Serial# that matches equipment of the selected type, the equipment will be updated and assigned to this employee.</li>
                    <li>If the serial# does not exist yet, a new equipment record will be created.</li>
                    <li>When editing equipment, since the serial# is already recognized, MeritEHS will perforam an update to this equipment.</li>
                    <li>If exiting equipment is assigned to this user, a history tracking record will be created if:
                        <ul>
                            <li>The equipment status does NOT = Issued.</li>
                            <li>Or the equipment is NOT already assigned to this employee</li>
                        </ul>
                    </li>
                    <li>If creating new equipment, a history tracking record for Issued will be created.</li>
                    <li>TO REMOVE Equipment:
                        <ul>
                            <li>Click the "Check In" action button</li>
                            <li>Complete the Check In requirements and update the equipment</li>
                            <li>The equipment will now be removed from the employee</li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            Equipment ({{ equipment.length }})
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered small">
                                <thead>
                                    <tr>
                                        <th>Actions</th>
                                        <th>Equipment Type <i class="fa fa-asterisk small text-danger"></i></th>
                                        <th>Model# <i class="fa fa-asterisk small text-danger"></i></th>
                                        <th>Serial# <i class="fa fa-asterisk small text-danger"></i></th>
                                        <th>Issue Date</th>
                                        <th>Next Maintenance Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(equip, i) in equipment" :key="equip.equipment_id">
                                        <td>
                                            <template v-if="equip.equipment_id">
                                                <router-link :to="`/equipment/tracking/${equip.equipment_id}/edit`" class="btn btn-sm btn-light">
                                                    <i class="fa fa-sign-in"></i> Check In
                                                </router-link>
                                            </template>
                                            <template v-else>
                                                Issued
                                            </template>
                                        </td>
                                        <td>
                                            <b-form-select v-model="equip.equipment_type_id" :options="equipmentTypeOptions" size="sm" :class="{'is-invalid': errors['equipment.'+i+'.equipment_type_id']}" />

                                            <span v-if="errors['equipment.'+i+'.equipment_type_id']" class="text-danger">
                                                <span v-for="(err, j) in errors['equipment.'+i+'.equipment_type_id']">
                                                    <span v-if="j > 0">, </span>{{ err }}
                                                </span>
                                            </span>
                                        </td>
                                        <td>
                                            <b-form-input v-model="equip.model_number" size="sm" placeholder="Enter Model#" :class="{'is-invalid': errors['equipment.'+i+'.model_number']}" />

                                            <span v-if="errors['equipment.'+i+'.model_number']" class="text-danger">
                                                <span v-for="(err, j) in errors['equipment.'+i+'.model_number']">
                                                    <span v-if="j > 0">, </span>{{ err }}
                                                </span>
                                            </span>
                                        </td>
                                        <td>
                                            <b-form-input v-model="equip.serial_number" size="sm" placeholder="Enter Unique Serial#" :class="{'is-invalid': errors['equipment.'+i+'.serial_number']}" />

                                            <a href="javascript:void(0)" v-on:click="setEquipmentSuggestedSerialNbr(equip)" v-if="!equip.serial_number && equip.equipment_type_id">
                                                Use Suggested: {{ getSuggestedSerialNbr(equip) }}
                                            </a>

                                            <span v-if="errors['equipment.'+i+'.serial_number']" class="text-danger">
                                                <span v-for="(err, j) in errors['equipment.'+i+'.serial_number']">
                                                    <span v-if="j > 0">, </span>{{ err }}
                                                </span>
                                            </span>
                                        </td>
                                        <td>
                                            <b-form-datepicker v-model="equip.issue_date" size="sm" />
                                        </td>
                                        <td>
                                            <b-form-datepicker v-model="equip.next_maintenance_date" size="sm" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <a href="javascript:void(0)" class="btn-add-record" v-on:click="addEquipment()"><i class="fa fa-plus-circle text-success"></i> Add Equipment</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-success" v-on:click="saveEquipment()" :disabled="saving">
                                <template v-if="saving">
                                    Updating <i class="fa fa-spinner fa-spin"></i>
                                </template>
                                <template v-else>
                                    Update
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                saving: false,
                userTimezone: this.$store.state.user.timezone,
                employee_id: this.$route.params.id,
                employee: {},
                equipment: [],
                equipment_types: [],
                errors: {},
            }
        },

        computed: {
            equipmentTypeOptions(){
                //Setup
                var options = [
                    {value: null, text: '-- Select Equipment Type --'},
                ];

                //Main loop to build the options
                for (var i = 0; i < this.equipment_types.length; i++)
                {
                    options.push({value: this.equipment_types[i].equipment_type_id, text: this.equipment_types[i].equipment_type_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getEquipment() {
                //Loading
                this.loading = true;

                //Get the data
                this.$http
                    .get(`employees/equipment/${this.employee_id}`)
                    .then(response => {
                        //Set all the data
                        this.employee = response.data.employee;
                        this.equipment = response.data.equipment;
                        this.equipment_types = response.data.equipment_types;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            addEquipment(){
                //Push
                this.equipment.push({
                    equipment_type_id: null,
                    model_number: null,
                    serial_number: null,
                    issue_date: moment().format('YYYY-MM-DD'),
                });
            },

            saveEquipment(){
                //Flag
                this.saving = true;

                //Sent it
                this.$http
                    .post(`employees/equipment/${this.employee_id}`, {equipment: this.equipment})
                    .then(response => {
                        //Set loading
                        this.loading = false;

                        //Alert
                        this.$toastr.success('Equipment Updated');

                        //Send to list
                        this.$router.push('/employees/view/'+this.employee_id);
                    })
                    .catch(error => {
                        //Check Response
                        if(error.response && error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error, 'Failed to Save Incident');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },

            getSuggestedSerialNbr(equip){
                //Build the Equipment Number using the TYPE, Employee Asset Type, and Employee ID
                var type = '';

                //Setup
                for (var i = 0; i < this.equipment_types.length; i++)
                {
                    //Check the ID
                    if(this.equipment_types[i].equipment_type_id == equip.equipment_type_id)
                    {
                        type = this.equipment_types[i].equipment_type_name;
                    }
                }

                //Characters to Replace
                var characters = {
                    " ": "-",
                    "(": "-",
                    ")": "-",
                    "'": "",
                    '"': "",
                };

                //Loop and Build
                var keys = Object.keys(characters);

                for (var i = 0; i < keys.length; i++)
                {
                    //Replace it
                    type = type.replace(keys[i], characters[keys[i]]);
                }

                //Append the Employee Type
                type += '-Employee-'+this.employee.EmployeeNumber;

                //Send it
                return type;
            },

            setEquipmentSuggestedSerialNbr(equip){
                //Set the value
                equip.serial_number = this.getSuggestedSerialNbr(equip);
            }

        },
        mounted() {
            //Get the users
            this.getEquipment();
        }
    }
</script>
